import { utils, writeFile } from 'xlsx';
import { saveAs } from 'file-saver';
import { JsonToExcelPayload } from '../types/fileGeneration';

// tablePayload: { header: string[]; body: (string|number|null|undefined)[][] }
export const downloadExcelFromJson = (
  fileName: string,
  sheetName: string,
  tablePayload: JsonToExcelPayload
) => {
  try {
    const { headers, body } = tablePayload;
    const dataWithHeaders = [headers, ...body];
    const worksheet = utils.aoa_to_sheet(dataWithHeaders);

    // Optional: set column widths based on header length
    const colWidths = headers.map((h) => ({
      width: Math.min(Math.max(h.length + 4, 12), 40)
    }));
    // @ts-ignore - adding custom property
    worksheet['!cols'] = colWidths;

    const workbook = utils.book_new();
    utils.book_append_sheet(workbook, worksheet, sheetName.substring(0, 31));
    writeFile(workbook, `${fileName}.xlsx`);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('Failed to generate Excel file', e);
  }
};

export const downloadCsvFromJson = (
  fileName: string,
  _p0: string,
  tablePayload: JsonToExcelPayload
) => {
  try {
    const { headers, body } = tablePayload;
    const escapeCell = (value: any) => {
      if (value === null || value === undefined) return '';
      const string = String(value);
      if (/[,"\n\r]/.test(string)) {
        return '"' + string.replace(/"/g, '""') + '"';
      }
      return string;
    };
    const lines: string[] = [];
    lines.push(headers.map(escapeCell).join(','));
    body.forEach((row) => {
      lines.push(row.map(escapeCell).join(','));
    });
    const csvContent = '\uFEFF' + lines.join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.href = url;
    link.download = fileName.endsWith('.csv') ? fileName : `${fileName}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('Failed to generate CSV file', e);
  }
};

export const downloadFileFromUrl = (
  url: string,
  fileName: string,
  fileType: string
) => {
  fetch(url)
    .then((response) => {
      if (!response.ok) throw new Error(String(response.status));
      return response.blob();
    })
    .then((blob) =>
      saveAs(
        blob,
        fileName.endsWith(`.${fileType}`) ? fileName : `${fileName}.${fileType}`
      )
    )
    .catch(() => saveAs(url, `${fileName}.${fileType}`));
};
